import { useEffect } from 'react';
import { setReferralSessionStorage } from '../Referral/setReferralSessionStorage';
import { setUtmSessionStorage } from './setUtmSessionStorage';

interface Props {
  search: string;
}

export function Utm({ search }: Props) {
  useEffect(() => {
    setUtmSessionStorage(search);
    // Cookbook-referral attribution rides the same capture points as UTM so it
    // survives to signup without a new mount. No-ops when the URL has no
    // referral params.
    setReferralSessionStorage(search);
  }, []);

  return <></>;
}
